export default "__VITE_ASSET__30ca3400__"